import service from "@/util/request";

export function login(username, password) {
  return service.post('/app/Organizer/login',{
    username,
    password
  });
}

export function getRaceList(search, start_date, end_date) {
  return service.get('/app/Organizer/raceList', {
    params: {
      search,
      start_date: start_date,
      end_date: end_date
    }
  });
}


export function createRace({ title, cycle, category_id, dateRange, endregtime, department_id, max_teamsize, min_teamsize, groups, groupDetailRaces, is_advisor, max_advisor }) {
  return service.post('/app/Organizer/CreateRace', {
    title,
    cycle,
    category_id,
    startdate: dateRange[0] / 1000,
    enddate: dateRange[1] / 1000,
    endregtime: endregtime / 1000,
    department_id,
    max_teamsize,
    min_teamsize,
    groups,
    group_detailRaces: groupDetailRaces,
    is_advisor,
    max_advisor // 新增
  })
}


export function updateRace({ races_id, category_id, title, cycle, dateRange, endregtime, max_teamsize, min_teamsize, department_id, is_advisor, max_advisor }) {
  return service.post('/app/Organizer/UpdateRace', {
    races_id,
    category_id,
    title,
    cycle,
    startdate: dateRange[0] / 1000,
    enddate: dateRange[1] / 1000,
    endregtime: endregtime / 1000,
    max_teamsize,
    min_teamsize,
    department_id,
    is_advisor,
    max_advisor // 新增
  });
}

export function deleteRace(races_id) {
  return service.post('/app/Organizer/DeleteRace', {
    races_id
  });
}

export function createDetailRace({ races_id, group, is_online, review_standard, awardrules, stage, passingnumber, is_publish_rank, is_publish_score }) {
  const req = {
    races_id,
    group,
    is_online,
    review_standard,
    stage,
    // 阶段级公布设置，默认不公布
    is_publish_rank: is_publish_rank ? 1 : 0,
    is_publish_score: is_publish_score ? 1 : 0
  };
  if (stage === 3) {
    req.awardrules = awardrules;
  } else {
    req.awardrules = [{ passingnumber }];
  }
  return service.post('/app/Organizer/CreateDetailRace', req);
}

export function updateDetailRace({ detailraces_id, races_id, group, is_online, review_standard, awardrules, stage, passingnumber, is_publish_rank, is_publish_score }) {
  const req = {
    detailraces_id,
    races_id,
    group,
    is_online,
    review_standard,
    stage,
    is_publish_rank: is_publish_rank ? 1 : 0,
    is_publish_score: is_publish_score ? 1 : 0
  }
  if (stage === 3) {
    req.awardrules = awardrules;
  } else {
    req.awardrules = [{ passingnumber }];
  }
  return service.post('/app/Organizer/UpdateDetailRace', req);
}

export function deleteOneDetailRace(detailraces_id) {
  return service.post('/app/Organizer/DeleteOneDetailRace', {
    detailraces_id
  });
}

export function deleteAllDetailRace(group, races_id) {
  return service.post('/app/Organizer/DeleteAllDetailRace', {
    races_id,
    group
  });
}

export function getCategoryList() {
  return service.get('/app/Organizer/categoryList');
}

export function calculateAllStudentScore(detailraces_id) {
  return service.post('/app/Organizer/calculateAllStudentScore', {
    detailraces_id
  });
}

export function goToNextDetailRaces(detailraces_id) {
  return service.post('/app/Organizer/goToNextDetailRaces', {
    detailraces_id
  });
}

export function getAgegroupList() {
  return service.get('/app/Organizer/ageGroupList');
}

export function getSignUpCodeUrl(raceId) {
  return service.post('/app/Organizer/getSignUpCodeUrl', {
    raceId: raceId.toString()
  });
}

export function getReviewersCodeUrl(reviewersNumber, detailRacesId) {
  return service.post('/app/Organizer/getReviewersCodeUrl', {
    reviewersNumber: reviewersNumber.toString(),
    detailRacesId: detailRacesId.toString()
  });
}

export function getTeamRacesList(id, search) {
  return service.post('/app/Organizer/getTeamRacesList', {
    detailraces_id: id,
    search
  });
}

// 数据统计：传一场赛事 = 单赛事口径；传全部赛事 = 累计（后端相加，不做跨赛事去重）
export function getRaceStatistics(racesIds) {
  return service.post('/app/Organizer/raceStatistics', {
    races_ids: racesIds
  });
}

export function setReviewResult(reviewTableId, score) {
  return service.post('/app/Organizer/setReviewResult', {
    reviewTableId,
    score
  });
}

export function getWhiteList(races_id) {
  return service.get('/app/Organizer/getWhiteList', {
    params: {
      races_id
    }
  });
}

export function addStudentToWhiteList(racesId, IdNumber) {
  return service.post('/app/Organizer/addStudentToWhiteList', {
    racesId,
    IdNumberList: [IdNumber]
  })
}

export function deleteStudentInWhiteList(id) {
  return service.post('/app/Organizer/deleteStudentInWhiteList', {
    idList: [id]
  });
}

export function insertTeacherCertByVIP(detailRacesId, phone) {
  return service.post('/app/Organizer/insertTeacherCertByVIP', {
    detailRacesId,
    phone
  });
}

export function getDescription(races_id) {
  return service.get('/app/Organizer/description', {
    params: {
      races_id
    }
  })
}

export function updateDescription(races_id, content) {
  return service.post('/app/Organizer/updateDescription', {
    races_id,
    content
  })
}

export function listReviewer(detailRacesId) {
  return service.get(`/app/Organizer/reviewersList/${detailRacesId}`)
}
